// ─── Supabase Client (Frontend) ─────────────────────────────────
// Public anon key — RLS enforced. Safe to expose in browser.
// Session stored in localStorage, auto-refreshed by Supabase JS.

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    '⚠️  VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY not set — auth will not work'
  );
}

/**
 * No-op lock function that bypasses Navigator LockManager.
 * Supabase JS uses navigator.locks.request() by default, which can
 * deadlock when a stale session token exists (e.g. after deleting a
 * user from the DB). This replaces it with a simple mutex that just
 * executes the callback immediately.
 */
const noopLock = async (
  _name: string,
  _acquireTimeout: number,
  fn: () => Promise<any>
): Promise<any> => {
  return await fn();
};

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true, // Required for OAuth callbacks
      lock: noopLock,           // Bypass Navigator LockManager deadlocks
    },
  }
);
